/**
 * Workaround to handle mobile phones where the browser toolbar (bottom) and address bar (top) can shrink and grow,
 *   causing components that are using 100vh to have inaccurate height.
 */
import functions from '../../utils/functions';
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let initialized = false;

  return () => {
    if (initialized) {
      // do not runs more then once
      return;
    }

    // helper to measure 100vh
    const div = $('<div>').css({
      'position': 'absolute',
      'left': '-100%',
      'top': 0,
      'pointer-events': 'none',
      'width': '1px',
      //'min-height': '100vh',
      'min-height': '-webkit-fill-available',
      'z-index': -1,
      'role': 'presentation',
      'aria-hidden': 'true'
    });
    div.appendTo('body');

    // for browsers that don't support fill-available or -moz-available for height/min-height
    if (div[0].style['min-height'] !== '100vh' && div[0].style['min-height'] !== '-webkit-fill-available') {
      div[0].style['min-height'] = '100vh';
    }

    const setHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      doc.style.setProperty('--viewport-height-min', `${Math.min(window.innerHeight, div.height())}px`);
    };

    window.addEventListener('orientationchange', setHeight);
    window.addEventListener('resize', functions.debounce(setHeight));

    setHeight();
  };

})(jQuery, window);